import { CEEntityPermissionAttributesBase } from './ce-entity-permission-attributes-base'


export class CEEntityPermissionAttributes extends CEEntityPermissionAttributesBase {

}